import React from 'react';
import { allResources } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
export function Offer() {
  const hasCheckout = Boolean(siteConfig.checkoutUrl);
  const ctaClass = 'inline-flex w-full justify-center whitespace-nowrap rounded-full bg-coral-deep px-8 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200';
  return <section id="offre" aria-labelledby="offer-title" className="scroll-mt-16 bg-teal-soft px-5 sm:px-8 py-16 sm:py-24" data-id="element-172" data-mp="tyv67diymhys">
      <div className="max-w-5xl mx-auto" data-id="element-173" data-mp="p0a6rgbj82be">
        <h2 id="offer-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal text-center" data-id="element-174" data-mp="p1l7t8dlevyt">
          Votre atelier créatif commence ici
        </h2>

        <div className="mt-10 sm:mt-14 grid md:grid-cols-[1.25fr_1fr] rounded-[2rem] bg-ivory overflow-hidden shadow-soft" data-id="element-175" data-mp="ywd4m9zcpesj">
          <ul className="p-6 sm:p-10 divide-y divide-ink/10" data-id="element-176" data-mp="2feamw4cy9rym">
            {allResources.map(r => <li key={r.id} className="flex items-center gap-4 py-3.5 first:pt-0 last:pb-0" data-id="element-177" data-mp="2actpwjxl6pnb">
                <div className="h-16 w-16 shrink-0 rounded-xl overflow-hidden bg-sand" data-id="element-178" data-mp="pjz29rln3bx7">
                  <img src={r.image} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-179" data-mp="uhqt0iajsrzt" />
                </div>
                <div className="min-w-0" data-id="element-180" data-mp="zgk4k569y8xc">
                  <p className="text-xs font-semibold text-coral-deep" data-id="element-181" data-mp="13iypqvxf1krs">
                    {r.kind === 'guide' ? 'Guide principal' : `Bonus ${r.number}`}
                  </p>
                  <p className="font-serif text-base sm:text-lg font-semibold text-teal leading-snug" data-id="element-182" data-mp="bsaqxqj7srha">
                    {r.name}
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="bg-sand p-8 sm:p-10 flex flex-col justify-center text-center" data-id="element-183" data-mp="kle0vounim76">
            <p className="text-sm font-medium text-ink/75" data-id="element-184" data-mp="3k95kgfe4gzip">6 ressources numériques</p>
            <p className="mt-2 font-serif text-6xl sm:text-7xl font-semibold text-teal" data-id="element-185" data-mp="3oa7iiswaz5j3">
              {siteConfig.price}
            </p>
            <p className="mt-3 text-sm text-ink/75" data-id="element-186" data-mp="vepap1gjv3v6">Paiement unique · Sans abonnement</p>

            <div className="mt-8" data-id="element-187" data-mp="qhfk3ihfcm5r">
              {hasCheckout ? <a href={siteConfig.checkoutUrl} className={`${ctaClass} hover:bg-coral-darker`} data-id="element-188" data-mp="qetgftxnmqst">
                  J’accède au pack — {siteConfig.price}
                </a> : <button type="button" disabled className={`${ctaClass} opacity-60 cursor-not-allowed`} data-id="element-189" data-mp="107s4nap8ofbw">
                  J’accède au pack — {siteConfig.price}
                </button>}
            </div>

            <p className="mt-5 text-[13px] leading-relaxed text-ink/70" data-id="element-190" data-mp="7j3bbxufdeap">
              Guides et modèles numériques à télécharger. Aucun livre imprimé ni
              matériel n’est expédié.
            </p>
          </div>
        </div>
      </div>
    </section>;
}